import { render, staticRenderFns } from "./SubNavbar.vue?vue&type=template&id=4ebff456&scoped=true&"
import script from "./SubNavbar.vue?vue&type=script&lang=js&"
export * from "./SubNavbar.vue?vue&type=script&lang=js&"
import style0 from "./SubNavbar.vue?vue&type=style&index=0&id=4ebff456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebff456",
  null
  
)

export default component.exports